/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Section_QuestionsInputs */

const en_marketing_section_questions = /** @type {(inputs: Marketing_Section_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

const es_marketing_section_questions = /** @type {(inputs: Marketing_Section_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas`)
};

const fr_marketing_section_questions = /** @type {(inputs: Marketing_Section_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

/**
* | output |
* | --- |
* | "Questions" |
*
* @param {Marketing_Section_QuestionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_section_questions = /** @type {((inputs?: Marketing_Section_QuestionsInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Section_QuestionsInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_section_questions(inputs)
	if (locale === "es") return es_marketing_section_questions(inputs)
	return fr_marketing_section_questions(inputs)
});